var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDressCodeForLadies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.061,9.329l.689-2.65c.166-.747,.25-1.514,.25-2.277V0h-1V2.044c-1.83,.217-3.322,1.542-4,2.26-.678-.718-2.17-2.043-4-2.26V0h-1V4.402c0,.764,.084,1.53,.254,2.295l.684,2.632L.249,16.136c1.95,4.741,6.6,7.872,11.751,7.864,5.151,.008,9.801-3.124,11.751-7.864l-7.69-6.806Zm-4.455-3.958l.395,.503,.393-.504c.017-.022,1.607-2.002,3.606-2.308v1.341c0,.691-.076,1.385-.223,2.043l-.664,2.555h-6.226l-.66-2.537c-.15-.676-.227-1.369-.227-2.061v-1.34c1.992,.307,3.589,2.287,3.606,2.309Zm.394,17.629c-4.505,0-8.601-2.58-10.536-6.604l7.225-6.396h6.621l7.226,6.396c-1.935,4.024-6.03,6.604-10.536,6.604Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDressCodeForLadies);
export default __webpack_public_path__ + "static/media/DressCodeForLadies.84a827e89085d203584f4addcb983aaa.svg";
export { ForwardRef as ReactComponent };